module.exports = __webpack_public_path__ + "static/img/7.254b553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/7.png
// module id = vRqZ
// module chunks = 0